import { BsGithub } from "react-icons/bs";
import { MdOutlineOpenInNew } from "react-icons/md";
import { SiFigma } from "react-icons/si";
import projectOne from "../assets/portfolio.png";

const Projects = () => {
  const data = [
    {
      id: 1,
      tools: ["React", "Tailwind", "Figma"],
      title: "Portfolio",
      desc: "",
      imgUrl: projectOne,
      githubLink: "https://github.com/wBlanck",
      liveLink: "",
      figmaLink:
        "https://www.figma.com/file/IbwyRmlUZpjjvFvFF9urVv/Untitled?node-id=0%3A1",
    },
    {
      id: 2,
      tools: ["HTML", "CSS", "Framer", "Figma"],
      title: "Project 2",
      desc: "",
      imgUrl: projectOne,
      githubLink: "",
      liveLink: "",
      figmaLink: "",
    },
    {
      id: 3,
      tools: ["NODE", "Tailwind", "Framer", "Figma"],
      title: "Project 3",
      desc: "",
      imgUrl: projectOne,
      githubLink: "",
      liveLink: "",
      figmaLink: "",
    },
    {
      id: 4,
      tools: ["React", "Tailwind", "Framer", "Figma"],
      title: "DONUT SHOP ",
      desc: "",
      imgUrl: projectOne,
      githubLink: "",
      liveLink: "",
      figmaLink: "",
    },
  ];

  return (
    <div className="w-full h-full p-4 py-40">
      <div className="relative flex items-center justify-center text-center">
        <span className="absolute hidden tracking-widest underline md:block lg:text-9xl opacity-5 md:text-8xl">
          PROJECTS
        </span>
        <h2 className="text-2xl text-gray-800 md:text-4xl dark:text-textHeading">
          Some Things I've{" "}
          <span className="text-gray-900 underline dark:text-highlight">
            Built
          </span>
        </h2>
      </div>

      {/* PROJECTS CONTAINER */}
      <div className="flex flex-wrap justify-center gap-4 mt-12 bg-transparent md:mt-44">
        {/* PROJECT CONTAINER */}

        {data.map(
          ({
            id,
            tools,
            title,
            imgUrl,
            githubLink,
            liveLink,
            figmaLink,
            desc,
          }) => {
            return (
              <div
                key={id}
                className="sm:max-w-[500px] md:max-w-[40vw] w-full min-h-[325px] flex flex-col items-start justify-end shadow-md relative xl:max-w-[575px] ">
                <div className={`absolute left-0 w-full h-full overlay-dark`}>
                  <img
                    src={imgUrl}
                    alt="Project Thumbnail"
                    className="object-cover w-full h-full"
                  />
                </div>

                <h5 className="z-10 self-end p-2 text-5xl text-textHeading opacity-5">
                  {title}
                </h5>
                <div className="z-10 flex items-center justify-between w-full p-2 dark:bg-gray-900">
                  <ul className="flex gap-4 text-xs text-gray-200 dark:text-textHeading">
                    {tools.map((tool, i) => (
                      <li key={i}>{tool}</li>
                    ))}
                  </ul>
                  <div className="flex gap-3 text-gray-200 dark:text-highlight">
                    {figmaLink && (
                      <a
                        href={figmaLink}
                        target="_blank"
                        rel="noreferrer"
                        className="duration-300 dark:hover:text-textHeading hover:text-gray-400">
                        <SiFigma size={20} />
                      </a>
                    )}

                    <a
                      href={liveLink}
                      target="_blank"
                      rel="noreferrer"
                      className="duration-300 dark:hover:text-textHeading hover:text-gray-400">
                      <MdOutlineOpenInNew size={20} />
                    </a>
                    <a
                      href={githubLink}
                      target="_blank"
                      rel="noreferrer"
                      className="duration-300 dark:hover:text-textHeading hover:text-gray-400">
                      <BsGithub size={20} />
                    </a>
                  </div>
                </div>
              </div>
            );
          }
        )}
      </div>
    </div>
  );
};

export default Projects;
